import { IViabizzunoLayout } from '@viabizzuno/models';
import { IOption } from '@websolutespa/bom-core';
import { Layout, Main, Meta } from '@websolutespa/bom-mixer-ui';
import { ReactLenis } from 'lenis/react';
import { Cursor, InnerPage } from '../../components';
import { BackToTop } from '../../components/BackToTop/BackToTop';
import {
  DownloadModalProvider,
  GalleryProvider,
  useLayoutViewportEffects,
  useScrollReveal,
} from '../../hooks';
import { DownloadModal, Footer, Header } from '../../sections';

export type LayoutDefaultProps = {
  children?: React.ReactNode & { props: { layout: IViabizzunoLayout } };
};

export function LayoutDefault({ children }: LayoutDefaultProps) {
  useLayoutViewportEffects();
  useScrollReveal();

  const layout = children?.props?.layout as IViabizzunoLayout;
  const { headerProps, contact } = layout;

  const countryOptions: IOption[] = [
    { id: 'it', name: 'Italia' },
    { id: 'fr', name: 'Francia' },
    { id: 'de', name: 'Germania' },
    { id: 'es', name: 'Spagna' },
  ];

  const provincesOptions: IOption[] = [
    { id: '1', name: 'Napoli' },
    { id: '2', name: 'Roma' },
    { id: '3', name: 'Milano' },
    { id: '4', name: 'Torino' },
    { id: '5', name: 'Venezia' },
    { id: '6', name: 'Bologna' },
    { id: '7', name: 'Firenze' },
    { id: '8', name: 'Genova' },
    { id: '9', name: 'Napoli' },
    { id: '10', name: 'Palermo' },
  ];

  return (
    <GalleryProvider>
      <DownloadModalProvider
        countries={countryOptions}
        provinces={provincesOptions}>
        <Meta />
        <Layout>
          <ReactLenis
            root
            options={{
              lerp: 0.08,
              smoothWheel: true,
              anchors: {
                offset: 20,
              },
            }}>
            <Cursor />
            <Header {...headerProps} />
            <Main>
              <InnerPage>{children}</InnerPage>
            </Main>
            <Footer contact={contact} />
            <DownloadModal />
            <BackToTop />
          </ReactLenis>
        </Layout>
      </DownloadModalProvider>
    </GalleryProvider>
  );
}
